<template>
  <div class="foot-nav">
    <div class="w-full max-w-4xl flex justify-center">
      <router-link to="/dashboard" class="nav-items">
        <div class="item-image">
          <img class="w-8" src="../assets/images/nav_home.png" />
        </div>
        <div class="item-text">Home</div>
      </router-link>
      <router-link to="/start-projects" class="nav-items">
        <div class="item-image">
          <img class="w-8" src="../assets/images/nav_projects.png" />
        </div>
        <div class="item-text">Project</div>
      </router-link>
      <router-link to="/carbon-footprint" class="nav-items">
        <div class="item-image">
          <img class="w-8" src="../assets/images/nav_footprint.png" />
        </div>
        <div class="item-text">Footprint</div>
      </router-link>
      <router-link to="/personal-center" class="nav-items">
        <div class="item-image">
          <img class="w-8" src="../assets/images/nav_profile.png" />
        </div>
        <div class="item-text">Profile</div>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped>
.foot-nav {
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  justify-content: center;
  background-color: #fff;
  padding: 0.5rem 0;
  z-index: 10;
}

.nav-items {
  width: 25%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
</style>